import { render, staticRenderFns } from "./BuyBusienesAssoclate.vue?vue&type=template&id=663ba040&scoped=true&"
import script from "./BuyBusienesAssoclate.vue?vue&type=script&lang=js&"
export * from "./BuyBusienesAssoclate.vue?vue&type=script&lang=js&"
import style0 from "./BuyBusienesAssoclate.vue?vue&type=style&index=0&id=663ba040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ba040",
  null
  
)

export default component.exports